/**
 * import react
 */
import React, { useState } from 'react';
import PropTypes from 'prop-types';

/**
 * import material-ui/core
 */
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';

/**
 * import material-ui/icons
 */
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';


/**
 * constant
 */
import { constVal } from '../slot-const';
import Typography from '@material-ui/core/Typography';

const AuthDialog = (props={}) => {
  const [userName, setUserName] = useState(props.userName || '');
  const [password, setPassword] = useState(props.password || '');
  const [comment, setComment] = useState(props.comment || '');
  const [showPassword, setShowPassword] = useState(false);
  const [isNotEmptyLabel, setIsNotEmptyLabel] = useState(true);

  const { helpText = ''} = props;

  const handleOnChange = (type) => {
    return (e) => {
      const { value = '' } = e.target;
      const fn = { username: setUserName, password: setPassword, comment: setComment };
      fn[type](() => value);
    };
  };

  const hadleCloseOnClick = () => {
    if(comment === '')
      setIsNotEmptyLabel(false);
    else {
      setIsNotEmptyLabel(true);
      props.handleAuthDialogClose({userName, password, comment, testedStatus: constVal.INITIAL});
    }
  };

  return (
    <Dialog open={true} maxWidth="lg">
      <DialogTitle>Please enter camera credential</DialogTitle>
      <DialogContent>
        <div style={{ fontSize: '1rem' }}>{helpText}</div>
        <TextField label="userName" fullWidth value={userName} onChange={handleOnChange('username')}/>
        <FormControl fullWidth>
          <InputLabel>password</InputLabel>
          <Input
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={handleOnChange('password')}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword(prev => !prev)}
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
        {
          props.isAssign
            ? <TextField label="label" fullWidth value={comment} onChange={handleOnChange('comment')}/>
            : null
        }
        <Typography hidden={isNotEmptyLabel}>{'Camera label is mandatory. Please enter label and try again.'}</Typography>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={hadleCloseOnClick}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

AuthDialog.propTypes = {
  helpText: PropTypes.string.isRequired,
  handleAuthDialogClose: PropTypes.func.isRequired,
  userName: PropTypes.string,
  password: PropTypes.string,
  comment: PropTypes.string,
  isAssign: PropTypes.bool
};

export default React.memo(AuthDialog);
